import * as PIXI from 'pixi.js';

// source: https://github.com/pixijs/pixi.js/issues/5131#issuecomment-424198220
export default function (from, to, height, width) {
  const canvas = document.createElement('canvas');
  canvas.height = height;
  canvas.width = width;
  const context = canvas.getContext('2d');
  const gradient = context.createLinearGradient(0, 0, 0, height);
  gradient.addColorStop(0, from);
  gradient.addColorStop(1, to);
  context.fillStyle = gradient;
  context.fillRect(0, 0, width, height);
  return PIXI.Texture.from(canvas);
}
